import http from './http.service';

class SpecialOfferService {
    constructor() {
        if (SpecialOfferService.instance) {
            return SpecialOfferService.instance;
        }

        SpecialOfferService.instance = this;
    }

    specialOffers() {
        return http.get('/special-offer').then(res => res.data);
    }
    store(data) {
        return http.post('/special-offer/store', data).then(res => res.data);
    }
    show(offerId) {
        return http.get(`/special-offer/${offerId}/show`).then(res => res.data);
    }
    update(offerId, data) {
        return http.put(`/special-offer/${offerId}/update`, data).then(res => res.data);
    }
    removeVehicleFromOffer(offerId, vehicleId) {
        return http.put(`/special-offer/${offerId}/remove-vehicle/${vehicleId}`).then(res => res.data);
    }
    destroy(offerId) {
        return http.delete(`/special-offer/${offerId}/destroy`).then(res => res.data);
    }
    destroyImg(offerId) {
        return http.delete(`/special-offer/${offerId}/destroy-img`).then(res => res.data);
    }
}

export default new SpecialOfferService();
